import PageHero from "../../components/PageHero/PageHero";
import contactHeroImage from "../../assests/images/Contact-Hero.jpg";
import ContactInfo from "../../components/ContactInfo/ContactInfo";
import ContactForm from "../../components/ContactForm/ContactForm";
import WhatsAppBanner from "../../components/WhatsAppBanner/WhatsAppBanner";

function Contact() {
  return (
    <>
      <PageHero
        badge="Contact MobileFix UAE"
        title="Need Mobile Repair Service? We're Ready To Help"
        description="Contact our team for fast and reliable mobile repair services. Whether you need a screen replacement, battery replacement, software support, or water damage repair, we're just a call or message away."
        backgroundImage={contactHeroImage}
      />
      <ContactInfo />
      <ContactForm />
      <WhatsAppBanner />
    </>
  );
}

export default Contact;
